import { Table, TableHead, TableRow, TableBody, TableCell } from '@mui/material'
import { BrokenImage } from '@mui/icons-material'

interface IAdCreative {
  readonly thumbnailURL: string
  readonly imageURL: string
}

interface IAdSet {
  readonly name: string
}

interface IAdItem {
  readonly id: string
  readonly internalCreatedAt: string
  readonly originalId: string
  readonly adAccountId: string
  readonly combinedId: string
  readonly name: string
  readonly frequency: number | null
  readonly impressions: number | null
  readonly clicks: number | null
  readonly ctr: number | null
  readonly uniqClicks: number | null
  readonly linkClicks: number | null
  readonly leads: number | null
  readonly avgPlaybackTime: number | null
  readonly adSetId: string
  readonly creativeId: string
  readonly originalMetaCampaignId: string
  readonly adSet: IAdSet
  readonly creative: IAdCreative
}

interface IOrderAnalyticsTable {
  readonly adsData: IAdItem[]
  readonly onOpenImage: (src: string | null, alt: string) => void
}

const OrderAnalyticsTable = ({ adsData, onOpenImage }: IOrderAnalyticsTable) => (
  <Table
    sx={{
      '& .MuiTableCell-root': {
        paddingLeft: 0,
      },
    }}
  >
    <TableHead>
      <TableRow>
        <TableCell>Thumbnail</TableCell>
        <TableCell>Ad Set Name</TableCell>
        <TableCell>Clicks</TableCell>
        <TableCell>Impressions</TableCell>
        <TableCell>CTR</TableCell>
        <TableCell>Frequency</TableCell>
        <TableCell>Leads</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {adsData.map((ad) => (
        <TableRow key={ad.id}>
          <TableCell>
            {ad.creative?.thumbnailURL ? (
              <img
                src={ad.creative.thumbnailURL}
                alt={ad.name ?? 'Ad Thumbnail'}
                style={{
                  width: window.innerWidth < 600 ? '40px' : '100px',
                  height: 'auto',
                  cursor: 'pointer',
                  objectFit: 'contain',
                }}
                onError={(e) => {
                  // eslint-disable-next-line
                  ;(e.currentTarget as HTMLImageElement).style.display = 'none'
                }}
                loading="lazy"
                onClick={() =>
                  onOpenImage(
                    ad.creative.imageURL || ad.creative.thumbnailURL,
                    ad.name ?? 'Ad Thumbnail'
                  )
                }
              />
            ) : (
              <BrokenImage
                style={{ width: window.innerWidth < 600 ? '40px' : '100px', height: 'auto' }}
              />
            )}
          </TableCell>
          <TableCell>{ad.adSet?.name ?? 'N/A'}</TableCell>
          <TableCell>{ad.clicks ?? 'N/A'}</TableCell>
          <TableCell>{ad.impressions ?? 'N/A'}</TableCell>
          <TableCell>
            {ad.ctr ? Number(ad.ctr).toFixed(2).replace('.', ',') : 'N/A'}
            {ad.ctr && '%'}
          </TableCell>
          <TableCell>
            {ad.frequency ? Number(ad.frequency).toFixed(2).replace('.', ',') : 'N/A'}
          </TableCell>
          <TableCell>{ad.leads ?? 'N/A'}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
)

export default OrderAnalyticsTable
